import React from "react";

export default function SectionHeader({ kicker, title, description, align = "left", testIdPrefix = "section" }) {
  const alignClass = align === "center" ? "text-center mx-auto max-w-2xl" : "text-left max-w-3xl";
  return (
    <div className={alignClass} data-testid={`${testIdPrefix}-header`}>
      {kicker && (
        <div className="font-mono-spec text-xs text-amber-400 mb-4">{kicker}</div>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-slate-400 text-base sm:text-lg leading-relaxed">{description}</p>
      )}
    </div>
  );
}
